import { useState } from "react";
import { taskService } from "@miplatform/api";
import { HTTP_STATUSES, ISSUE_IMAGE_TYPES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import {
  externalReferenceId,
  getDocumentTypeByContentType,
} from "@miplatform/utils";
import { useDocumentsViewModel } from "@miplatform/view-models";

export const useIssueEditorViewModel = ({ orderTemplateId }) => {
  const [issueTemplates, setIssueTemplates] = useState([]);
  const [documents, setDocuments] = useState([]);

  const { uploadDocument } = useDocumentsViewModel();

  const stateManager = useComponentState();

  const getAssignmentTemplates = async () => {
    const res = await taskService.orderTemplates.getById({
      id: orderTemplateId,
    });

    if (res.status === HTTP_STATUSES.OK) {
      setIssueTemplates(res.data.issueTemplates);
    }
  };

  const createIssue = async (data) =>
    stateManager.run(async () =>
      taskService.issues.create({
        data,
        toastMessageConfig: {
          success: {
            text: `The task was added successfully!`,
          },
        },
      })
    );

  const saveDocuments = async (issueId) => {
    await Promise.all(
      documents.map((file) => {
        return uploadDocument({
          file,
          documentType: getDocumentTypeByContentType(file.type),
          externalData: JSON.stringify({
            imageType: ISSUE_IMAGE_TYPES.ORIGINATING,
          }),
          externalReferenceId: externalReferenceId.getIssueRefId({ issueId }),
        });
      })
    );
  };

  return {
    createIssue,
    getAssignmentTemplates,
    issueTemplates,
    setDocuments,
    saveDocuments,
  };
};
